export function buildCreatePreviewTemplate({
  basicInfoForm,
  channelKey,
  editorContent,
  customStyle = '',
  checkedDisclosures,
  logoUrl,
  senderInfo,
}) {
  return {
    name: basicInfoForm.templateName,
    channel: channelKey,
    subjects: (basicInfoForm.subjects ?? []).filter(Boolean),
    htmlContent: editorContent,
    // Carried from the loaded template so the live preview iframe keeps its responsive CSS
    // (@media) — the editor body can change, but these at-rules are not editable in TinyMCE.
    customStyle,
    disclosures: checkedDisclosures.map((d) => ({ name: d.name })),
    logoUrl: logoUrl ?? null,
    senderInfo: senderInfo ?? null,
  };
}
